/** clsx + tailwind-merge, narrow surface. Keeps class composition tidy in
 *  the panels — `cn("base", cond && "extra", className)`. */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
